/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { TokenAmount, TokenAmountFromJSON, TokenAmountFromJSONTyped, TokenAmountToJSON } from './TokenAmount'

/**
 *
 * @export
 * @interface TradingTransactionTokenAmounts
 */
export interface TradingTransactionTokenAmounts {
  /**
   *
   * @type {TokenAmount}
   * @memberof TradingTransactionTokenAmounts
   */
  token0?: TokenAmount
  /**
   *
   * @type {TokenAmount}
   * @memberof TradingTransactionTokenAmounts
   */
  token1?: TokenAmount
  /**
   *
   * @type {TokenAmount}
   * @memberof TradingTransactionTokenAmounts
   */
  cashbackToken?: TokenAmount
}

export function TradingTransactionTokenAmountsFromJSON(json: any): TradingTransactionTokenAmounts {
  return TradingTransactionTokenAmountsFromJSONTyped(json, false)
}

export function TradingTransactionTokenAmountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TradingTransactionTokenAmounts {
  if (json === undefined || json === null) {
    return json
  }
  return {
    token0: !exists(json, 'token0') ? undefined : TokenAmountFromJSON(json['token0']),
    token1: !exists(json, 'token1') ? undefined : TokenAmountFromJSON(json['token1']),
    cashbackToken: !exists(json, 'cashbackToken') ? undefined : TokenAmountFromJSON(json['cashbackToken']),
  }
}

export function TradingTransactionTokenAmountsToJSON(value?: TradingTransactionTokenAmounts | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    token0: TokenAmountToJSON(value.token0),
    token1: TokenAmountToJSON(value.token1),
    cashbackToken: TokenAmountToJSON(value.cashbackToken),
  }
}
